<template>
    <div>
        <pro-zhu-shou 
        v-if="type==='xmzl'" 
        :row="row" 
        @cancle="$emit('cancle')" >
        </pro-zhu-shou>

        <complete-pro
        v-if="type==='xmdm'" 
        :row="row" 
        @reloadpage="$emit('reloadpage')"
        @cancle="$emit('cancle')" >
        </complete-pro>

        <project-ly
        v-if="type==='add'"
        @cancle="$emit('cancle')" >
        </project-ly>
    </div>
</template>

<script>
export default {
    components: {
        ProZhuShou: () => import('./agreements/prozhushou'),
        CompletePro: () => import('./agreements/completePro'),
        ProjectLy: () => import('./agreements/projectly')
    },
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        type:{
            type:String,
            default:''
        }
    },
    data: () => ({
        data: {},
    }),
    computed: {
        procode() {
            if(this.row.procode){
                return this.row.procode
            }else{
                return (this.row.zbprocode || '').substr(0, 17);
            }
           
        }
    },
    methods: {
        
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
.pdf-content{ height:500px; position:relative; }
</style>
